<script setup lang="ts">
import SiteLayout from '@/client/layouts/SiteLayout.vue';
import type { OfferContent, SitePageProps } from '@/client/types';
import { Head, Link } from '@inertiajs/vue3';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

/**
 * The public offer: the terms accepted in the request form before it is filled in.
 */
const props = defineProps<
    SitePageProps & {
        offer: OfferContent;
    }
>();

const { t } = useI18n();

const title = computed(() => props.offer.title || t('site.public_offer'));
</script>

<template>
    <Head :title="`${title} — ${brandName}`" />

    <SiteLayout :site="props">
        <article class="mx-auto grid max-w-3xl gap-6 px-4 py-16">
            <Link :href="homeUrl" class="text-sm text-muted-foreground hover:text-foreground">← {{ $t('site.back_home') }}</Link>
            <h1 class="text-3xl font-semibold tracking-tight md:text-4xl">{{ title }}</h1>
            <p v-if="offer.text" class="leading-relaxed whitespace-pre-line text-muted-foreground">{{ offer.text }}</p>
        </article>
    </SiteLayout>
</template>
